import { render, staticRenderFns } from "./LegalMinimumWageOverview.vue?vue&type=template&id=781edc12&scoped=true"
import script from "./LegalMinimumWageOverview.vue?vue&type=script&lang=js"
export * from "./LegalMinimumWageOverview.vue?vue&type=script&lang=js"
import style0 from "./LegalMinimumWageOverview.vue?vue&type=style&index=0&id=781edc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781edc12",
  null
  
)

export default component.exports